const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'templates',
		'newsletter',
		'form',
		'form'
	],

	config: {
		resourceConnected: false,
	},

	methods: {
		save: function(){
			var self = this;
			var newsletterTemplate = String(this.$.find('[data-field-code="newsletterTemplate"]').val() || '');
			var subject = String(this.$.find('[data-field-code="subject"]').val() || '');
			var newsletterID = newsletterTemplate.split('_');
			var templateID = newsletterID.pop();
			newsletterID = newsletterID[0];

			if(subject && newsletterID && templateID){
				return self.performAction(self.prepareAction('insert_mailing', undefined, undefined, {
					source: {
						submit: {
							data: {
								data: {
									attributes: {
										newsletterID: 	newsletterID,
										subject: 		subject
									},
									children: {
										cms_routes: {
											data: {
												attributes: {
													templateID: templateID
												}
											}
										}
									}
								}
							}
						}
					}
				}));
			}
			return utils.promise.reject(new Error('INCOMPLETE DATA FOR NEW MAILING'));
		}
	}
};